document.addEventListener("DOMContentLoaded", function () {
  const fingerSizeBtns = document.querySelectorAll(".category-size-btn");
  fingerSizeBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      if (this.classList.contains("disabled")) return;
      fingerSizeBtns.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");
      const fingerSizeInput = document.querySelector(
        'input[name="properties[Size]"]'
      );
      if (fingerSizeInput) {
        fingerSizeInput.value = this.getAttribute("data-size");
      }
    });
  });
});
